import { render, staticRenderFns } from "./categoryModel.vue?vue&type=template&id=0c4c9f90"
import script from "./categoryModel.vue?vue&type=script&lang=js"
export * from "./categoryModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4c9f90')) {
      api.createRecord('0c4c9f90', component.options)
    } else {
      api.reload('0c4c9f90', component.options)
    }
    module.hot.accept("./categoryModel.vue?vue&type=template&id=0c4c9f90", function () {
      api.rerender('0c4c9f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/categoryLabelManage/categoryModel.vue"
export default component.exports